import { track } from 'track'
import { localSavedStatesStore } from '@/state/localSavedStatesStore'
import { ListType } from '@/state/reducers'

export async function areThereUnsavedChanges(currentState: ListType) {
  // Shared lists are the initial, read-only baseline until a content reducer
  // clears this flag in response to a user edit.
  if (currentState.meta.isSharedList) {
    return false
  }
  // current state has not been saved, but there's nothing to save
  if (!currentState.meta.key && currentState.options.length === 0) {
    return false
  }
  // current state has been saved, but there are unsaved changes
  if (currentState.meta.key) {
    const savedState = await localSavedStatesStore.getItem(
      currentState.meta.key,
    )

    if (!savedState) {
      // todo handle this error case better
      console.error('Saved state not found', currentState.meta.key)
      return false
    }

    const { meta: _cm, ...currentStateCopy } = currentState
    const { meta: _sm, ...savedStateCopy } = savedState as ListType

    // current state equals saved state, no unsaved changes
    if (JSON.stringify(currentStateCopy) === JSON.stringify(savedStateCopy)) {
      return false
    }
  }
  return true
}

export async function confirmUnsavedChanges(
  state: ListType,
  message?: string,
  trackMessagePrefix?: string,
  askBeforeDiscarding = true,
) {
  const unsavedChanges = await areThereUnsavedChanges(state)
  if (!unsavedChanges) {
    return true
  }
  if (!askBeforeDiscarding) {
    track(
      'event',
      `${trackMessagePrefix}${trackMessagePrefix ? '-and-' : ''}discard-unsaved-list`,
    )
    return true
  }
  const confirmSave = window.confirm(message)
  track(
    'event',
    confirmSave
      ? `${trackMessagePrefix}${
          trackMessagePrefix ? '-and-' : ''
        }discard-unsaved-list`
      : `${trackMessagePrefix}${
          trackMessagePrefix ? '-but-' : ''
        }do-not-discard-unsaved-list`,
  )
  return confirmSave
}
